import React from "react";
import Modal from "./modal/Modal";
import Error from "../Error";
import Dependencies, { getVisibleDependencies } from "./Dependencies";

const DependenciesModal = ({
  show,
  close,
  dependencies,
  status,
  board_attributes,
  boarddata,
  users,
  rows,
  onSubmit,
  title = "Update required for the below fields",
  className = "dependencies-modal",
}) => {
  const visibleDeps = getVisibleDependencies(dependencies, rows, status);

  if (!show || Object.keys(visibleDeps).length === 0) {
    return null;
  }

  return (
    <Error>
      <Modal
        show={show}
        close={close}
        className={className}
        title={title}
      >
        <Dependencies
          dependencies={dependencies}
          close={close}
          status={status}
          board_attributes={board_attributes}
          boarddata={boarddata}
          users={users}
          rows={rows}
          onSubmit={onSubmit}
        />
      </Modal>
    </Error>
  );
};

export default DependenciesModal;
